import { SAMPLE_REQUEST_TYPES } from '@/constants/constant';

import { checkAnyUserType } from '@/utils/Util';

// validation schemas
export const VALIDATION_SCHEMAS = {
	[SAMPLE_REQUEST_TYPES.SEND_TO_PD_IN_HOUSE]: {
		primaryTargetCustomar: { required: true, message: 'Primary target customer is required' },
		sampleType: { required: true, message: 'Sample type is required' },
		requiredDate: { required: true, message: 'Required date is required' },
		expectedOrderDate: checkAnyUserType(['ACCOUNT_MANAGER'])
			? {
					required: true,
					message: 'Expected order date is required'
				}
			: {}
	},
	[SAMPLE_REQUEST_TYPES.SEND_TO_FACTORY_NITEX_DESIGN]: {
		factorySubmitionToNitexDate: { required: true, message: 'Factory submission to Nitex is required' },
		requestFor: { required: true, message: 'Request for is required' },
		sampleType: { required: true, message: 'Sample type is required' },
		factoryName: { required: true, message: 'Factory name is required' },
		expectedOrderDate: checkAnyUserType(['ACCOUNT_MANAGER'])
			? {
					required: true,
					message: 'Expected order date is required'
				}
			: {}
	},
	[SAMPLE_REQUEST_TYPES.SEND_TO_FACTORY_BUYER_DESIGN]: {
		// expectedOrderDate: { required: true, message: 'Expected order date is required' },
		factorySubmitionToNitexDate: { required: true, message: 'Factory name is required' },
		sampleType: { required: true, message: 'Sample type is required' },
		factoryName: { required: true, message: 'Factory name is required' }
	},
	[SAMPLE_REQUEST_TYPES.SAMPLE]: {
		requiredDate: { required: true, message: 'Required date is required' }
		// requestFor: { required: true, message: 'Request for is required' }
		// sampleType: { required: true, message: 'Sample type is required' }
	},
	[SAMPLE_REQUEST_TYPES.SEND_REVISE_SAMPLE_REQUEST]: {
		requiredDate: { required: true, message: 'Required date is required' }
		// requestFor: { required: true, message: 'Request for is required' }
		// sampleType: { required: true, message: 'Sample type is required' }
	},
	[SAMPLE_REQUEST_TYPES.TP_HANDOVER]: {
		handoverPurpose: { required: true, message: 'Handover Purpose is required' },
		handoverToPerson: { required: true, message: 'Handover to person is required' }
	},

	[SAMPLE_REQUEST_TYPES.TP_HANDOVER_TO_PROJECT_TEAM]: {
		handoverPurpose: { required: true, message: 'Handover Purpose is required' },
		handoverToPerson: { required: true, message: 'Handover to person is required' }
	},
	[SAMPLE_REQUEST_TYPES.TP_HANDOVER_TO_ACCOUNT_MANAGER]: {
		handoverPurpose: { required: true, message: 'Handover Purpose is required' },
		handoverToPerson: { required: true, message: 'Handover to person is required' }
	},
	[SAMPLE_REQUEST_TYPES.TP_HANDOVER_TO_DESIGNER]: {
		handoverPurpose: { required: true, message: 'Handover Purpose is required' },
		handoverToPerson: { required: true, message: 'Handover to person is required' }
	}
};

export const INITIAL_STATE_FOR_SAMPLE_REQUEST_MODAL = {
	primaryTargetCustomar: null,
	projectName: null,
	sampleType: null,
	requiredDate: '',
	sendSampleTo: [],
	expectedOrderDate: '',
	factoryName: null,
	factorySubmitionToNitexDate: '',
	requestFor: null,
	brand: null,
	handoverToPerson: [],
	handoverPurpose: null,
	note: ''
};

export const SAMPLE_REQUEST_ENUM = {
	SAMPLE_DEVELOPMENT_TYPE_ENUM: 'info.nitex.app.product.SampleDevelopmentType'
};

export const TECHPACK_STATUS_TAG_COLORS = {
	PENDING: 'blue-3',
	COMPLETED: 'green-3',
	INCOMPLEATE: 'red-3'
};

export const REQUEST_FOR_SAMPLE_SECTION = [
	{
		id: 'SEND_TO_SAMPLE_SECTION',
		value: 'Send to sample section',
		label: 'Send to sample section'
	}
	// {
	// 	id: 'HOLD_SAMPLE_DEVELOPMENT',
	// 	value: 'Hold sample development',
	// 	label: 'Hold sample development'
	// },
	// {
	// 	id: 'RELEASE_SAMPLE_DEVELOPMENT',
	// 	value: 'Release style again',
	// 	label: 'Release style again'
	// }
];

export const REQUEST_FOR_FACTORY_NITEX = [
	{
		id: 'SEND_TO_FACTORY_NITEX_DESIGN',
		value: 'Send to Factory',
		label: 'Send to Factory'
	},
	{
		id: 'HOLD_SAMPLE_DEVELOPMENT',
		value: 'Hold sample development',
		label: 'Hold sample development'
	},
	{
		id: 'RELEASE_SAMPLE_DEVELOPMENT',
		value: 'Release style again',
		label: 'Release style again'
	}
];

export const TECHPACK_HANDOVER_STATE = {
	customerName: null,
	projectName: null,
	sampleType: null,
	handoverPurpose: null,
	handoverTo: null,
	note: ''
};
